import { Container } from "@mui/material";
import React from "react";
import Menu from "../../components/Menu";
import Footer from "../../components/Footer";

export const LayoutLegal = ({ children }) => {
  return (
    <>
      <Menu />
      <Container style={{ margin: "50px auto" }}>{children}</Container>
      <Footer />
    </>
  );
};
